import Axios, { AxiosPromise } from "axios";
import ApiClient from "../../../configs/axios.config";

/*
 * Product recommendations API methods
 * */
const ProductRecommendationsApi = {
  routes: {
    getProductRecommendations: "/v1/discovercards",
    mockGetProductRecommendations: "/productRecommendations",
    mockGetProductRecommendationById: "/productRecommendation",
    mockEditProductRecommendation: "editProductRecommendation",
    mockAddProductRecommendations: "/addProduct",
    mockDeleteProductRecommendations: "/deleteProduct",
    mockSortProductRecommendations: "/v1/discovercards/reorder",
  },
  methods: {
    getProductRecommendations: (): AxiosPromise => {
      // return ApiClient.get(ProductRecommendationsApi.routes.getProductRecommendations, {});
      return MocksClient.get(ProductRecommendationsApi.routes.mockGetProductRecommendations, {});
    },
    getProductRecommendation: (id: any): AxiosPromise => {
      // return ApiClient.get(`${ProductRecommendationsApi.routes.getProductRecommendations}/${id}`, {});
      return MocksClient.get(`${ProductRecommendationsApi.routes.mockGetProductRecommendationById}/${id}`, {});
    },
    createProductRecommendation: (product: any): AxiosPromise => {
      // return ApiClient.post(ProductRecommendationsApi.routes.mockAddProductRecommendations, product);
      return MocksClient.post(ProductRecommendationsApi.routes.mockAddProductRecommendations, product);
    },
    EditProductRecommendation: (product: any, id: any): AxiosPromise => {
      // return ApiClient.put(`${ProductRecommendationsApi.routes.getProductRecommendations}/${id}`, product);
      return MocksClient.put(`${ProductRecommendationsApi.routes.mockEditProductRecommendation}/${id}`, product);
    },
    deleteProductRecommendation: (id: string): AxiosPromise => {
      // return ApiClient.delete(`${ProductRecommendationsApi.routes.mockDeleteProductRecommendations}/${id}`, {});
      return MocksClient.delete(`${ProductRecommendationsApi.routes.mockDeleteProductRecommendations}/${id}`, {});
    },
  },
};

//TODO: Remove this after BE integration
const MocksClient = Axios.create({
  baseURL: "https://demo7445692.mockable.io/",
  timeout: 10000,
  headers: {
    "Security-Cookie": `${localStorage.getItem("securityCookie")}`,
    "XSRF-TOKEN": `${localStorage.getItem("xsrfToken")}`,
  },
});

export default ProductRecommendationsApi;
